// src/api/fuelTypeApi.js
import apiClient from "./axios"

// Get list of fuel types
export const getFuelTypes = async params => {
  const response = await apiClient.get("/fuel-types", { params })
  return response.data
}

// Get a single fuel type
export const getFuelType = async id => {
  const response = await apiClient.get(`/fuel-types/${id}`)
  return response.data
}

// Create fuel type
export const createFuelType = async data => {
  const response = await apiClient.post("/fuel-types", data)
  return response.data
}

// Edit fuel type
export const editFuelType = async ({ id, ...data }) => {
  const response = await apiClient.put(`/fuel-types/${id}`, data)
  return response.data
}

// Delete fuel type
export const deleteFuelType = async id => {
  const response = await apiClient.delete(`/fuel-types/${id}`)
  return response.data
}
